import { IAsset } from '../../../page-builder/interface/apiServiceInterface';
import { CloseIcon } from '../../../assets/icons/close-icon';
import { ImageDrawer } from './image-drawer';
import { AxiosInstance } from 'axios';

export type ImageSelectorProps = {
  selectedImage: IAsset;
  handleSubmit: (_selectedImage: IAsset) => void;
  baseService: AxiosInstance;
};

export const defaultImage = {
  fileName: '',
  imageUrl: '',
  imageType: 'upload',
  storeID: '',
  code: '',
};

export const ImageSelector = ({
  selectedImage,
  handleSubmit,
  baseService,
}: ImageSelectorProps) => {
  return (
    <>
      {selectedImage?.imageUrl && (
        <div className="p-2 flex justify-between items-center border border-dashed rounded-md border-gray-400 mb-2 shadow-xl ">
          <span className="break-all">{selectedImage?.fileName}</span>
          <span
            className="cursor-pointer"
            onClick={e => {
              e.stopPropagation();
              e.preventDefault();
              handleSubmit(defaultImage);
            }}>
            <CloseIcon />
          </span>
        </div>
      )}
      <ImageDrawer
        handleSubmit={handleSubmit}
        image={selectedImage}
        baseService={baseService}
      />
    </>
  );
};
